export default __webpack_public_path__ + "static/media/1.8dcab282.jpg";